<div id="multiFieldDurationPickerForm" [formGroup]="form" class="form-wrapper" autocomplete="off">
  <div class="input-wrapper">
    <input type="number"
            id="days"
            name="days"
            title="days"
            [min]="0"
            class="form-control input-field-with-unit--single-char"
            formControlName="days"
            autocomplete="off"
            appNumericDirective/>
    <span class="singlechar-unit">d</span>
  </div>
  <div class="input-wrapper">
    <input type="number"
            id="hours"
            name="hours"
            title="hours"
            [min]="0"
            class="form-control input-field-with-unit--single-char"
            formControlName="hours"
            autocomplete="off"
            appNumericDirective/>
    <span class="singlechar-unit">h</span>
  </div>
  <div class="input-wrapper">
    <input type="number"
            id="minutes"
            name="minutes"
            title="minutes"
            [min]="0"
            class="form-control input-field-with-unit--wide"
            formControlName="minutes"
            autocomplete="off"
            appNumericDirective/>
    <span class="multichar-unit">min</span>
  </div>
</div>
